/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import Spinner from '../../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SelectedClaimHeader from './SelectedClaimHeader';
import SelectedClaimTabContainer from './SelectedClaimTabContainer';
import DisplayErrorMessages from '../../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import { getgeneralsystemparameterDetails } from '../../../Check/store/action';
import { getOverrideSystemData } from '../../../../Maintain/RebateProgram/MaintainRebate/store/actions';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';

import {
  GetAndDispatchClaimByID,
  getClaimTableInfo,
  getSinglePageClaimData,
  PostNumOfUnits,
  resetEditedRows,
  searchClaimByNDC,
  setCellFocused,
  setClaimLoading,
  setDisabled,
  setErrorMessage,
  setNumOfUnitRes,
  setClaimExtraState,
  setSelectedClaim,
  setSinglePageClaimData,
  setTableData,
  handleSelectChangeFilter,
  getAllClaimReferenceData,
  setSelectedClaimMode,
  setEditedRows,
} from '../../store/action';
import { formatDateUnix } from '../../../../../SharedModules/utilities/dateUtilities';
import {
  FAIL_PROCESSING_REQUEST,
  SUPPLEMENTAL,
} from '../../../../../SharedModules/Errors/constantMessageData';
import DisplaySuccessMessages from '../../../../../SharedModules/Errors/SuccessMessage';
import {
  closeTab,
  handleScrollToEvent,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';

const SelectedClaim = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    selectedClaimIndex = 1,
    pageClaimData,
    selectedClaim = [],
  } = useSelector((state) => state.sharedState.claim);

  const claimReferenceData = useSelector(
    (state) => state.sharedState.claim.claimReferenceData
  );
  const getClaimInfo = useSelector(
    (state) => state.sharedState.claim.getClaimInfo
  );

  const systemParameter = useSelector(
    (state) => state.sharedState.displayCheck.systemParameter
  );

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const claimSelectByFilter = useSelector(
    (state) => state.sharedState.claim.claimSelectByFilter
  );
  const searchScreenReduxObj = useSelector(
    (state) => state.sharedState.claim?.searchScreenReduxObj
  );
  const disableBtn = useSelector((state) => state.sharedState.claim.disableBtn);
  const loading = useSelector((state) => state.sharedState.claim.loading);
  const selectedClaimMode = useSelector(
    (state) => state.sharedState.claim.selectedClaimMode
  );

  const tableData = useSelector((state) => state.sharedState.claim.tableData);
  const { selectBy, claimId, selectedClaimFilter } = useSelector(
    (state) => state.sharedState.claim
  );
  const editedData = useSelector((state) => {
    return state.sharedState.claim.editedData;
  });
  const unitResponse = useSelector((state) => {
    return state.sharedState.claim.unitResponse;
  });
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const isChecked = useSelector(
    (state) => state.sharedState.claim.disputeResolutionToggle
  );

  const errorPopupMessage = useSelector(
    (state) => state.sharedState.claim.errorPopupMessage
  );

  const extraState = useSelector((state) => state.sharedState.claim.extraState);
  const edit = useSelector((state) => state.sharedState.claim.extraState.edit);
  const rebateType = useSelector((state) => state.sharedState.claim.rebateType);
  // const selectBy = useSelector((state) => state.sharedState.claim.selectBy);
  const errorMessage = useSelector(
    (state) => state.sharedState.claim.errorMessage
  );
  const userId = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data?.userId
  );
  const setStateChange = (key, val) => {
    setState({
      ...extraState,
      [key]: val,
    });
  };

  const setState = (value) => dispatch(setClaimExtraState(value));
  const localStore = JSON.parse(localStorage.getItem('tabItemsData'));
  const [isMounted, setIsMounted] = useState();
  const [fullScreen, setFullScreen] = useState(false);
  const [tableFullScreen, setTableFullScreen] = useState(false);
  const [oldSelectedClaim, setOldSelectedClaim] = useState(null);

  // const [disableBtn, setDisableBtn] = useState(true);
  const [successMessages, setSuccessMessages] = React.useState([]);
  const [open, setOpen] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [willCloseTab, setWillCloseTab] = useState(false);
  const [beforeSaveModeVal, setBeforeSaveModeVal] = useState('');

  React.useEffect(() => {
    if (
      tableData &&
      errorMessage &&
      typeof errorMessage === "string" &&
      errorMessage.trim().length > 0 &&
      errorMessage === constantMessageData.FAILED_MESSAGE_GENERIC
    ) {
      resetForm();
    }
  }, [errorMessage]);

  React.useEffect(() => {
    if (!claimReferenceData) {
      dispatch(getAllClaimReferenceData());
      dispatch(handleSelectChangeFilter(null, 'claimCategoryCd', 'ALL'));
    }
  }, [claimReferenceData]);
  useEffect(() => {
    dispatch(getgeneralsystemparameterDetails());
    dispatch(getOverrideSystemData({}));
    dispatch(setErrorMessage([]));
    handleScrollToEvent();
  }, []);
  const getPageClaimsData = async () => {
    if (selectedClaim.length > 0) {
      if (selectBy === 'claimId') {
        await dispatch(
          setSinglePageClaimData(
            selectedClaim[selectedClaimIndex - 1]?.claimVOList
          )
        );
        dispatch(setClaimLoading(false));
      } else {
        const SelectedClaimCopy =
          selectedClaim[selectedClaimIndex - 1]?.claimResultVOList;
        const payload = SelectedClaimCopy?.map((item) => {
          return {
            claimId: item.claimId,
            claimLineNum: item.claimLineNum,
            userID: logInUser?.toUpperCase(),
            functionCode: 'Claim',
            eventInquryKeyVO: [
              {
                keyType: 'claimId',
                key: `${item.claimId}-${item.claimLineNum}`,
              },
            ],
          };
        });
        await dispatch(getSinglePageClaimData(payload));
        dispatch(setClaimLoading(false));
      }
    }
  };
  // useEffect(() => {
  //   getPageClaimsData();
  // }, [selectedClaimIndex, selectedClaim]);

  React.useEffect(() => {
    if (getClaimInfo) {
      dispatch(getClaimTableInfo(false));
      getPageClaimsData();
    }
  }, [getClaimInfo]);

  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs?.map((item) => {
        if (item.navTo === '/claim') {
          if (errorPopupMessage?.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorPopupMessage]);

  // Tab highlighter POC
  React.useEffect(() => {
    const errMsg = errorPopupMessage;
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs?.map((item) => {
        if (item.navTo === '/selected-claim' && edit) {
          item.isFormDirty = true;
        } else {
          item.isFormDirty = false;
        }
        if (item.navTo === '/units-selected-claim') {
          if (edit && !_.isEmpty(errMsg)) {
            item.isFormError = true;
            dispatch(setErrorMessage([]));
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [edit, errorPopupMessage]);

  // Close Popup POC---
  useEffect(() => {
    setIsMounted(true);
  }, []);

  const saveAndCloseTab = () => {
    setWillCloseTab(true);
    saveUnits();
  };

  useEffect(() => {
    if (isMounted) {
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      if (
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.filter((x) => {
          return x.navTo === '/selected-claim' && x.isFormSave;
        }).length > 0
      ) {
        const newObj = updateTabs?.map((item) => {
          if (item.navTo === '/selected-claim' && item.isFormSave) {
            item.isFormSave = false;
            saveAndCloseTab();
          }
          return item;
        });
        localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      }
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  const openSave = () => {
    setSuccessMessages([]);
    dispatch(setErrorMessage([]));
    setOpen(true);
  };

  function resetForm() {
    setSuccessMessages([]);
    // const clone = JSON.parse(JSON.stringify(reportQtr));
    // setReportQtrDetailList({ ...clone });
    dispatch(setCellFocused(-1));
    setOpenCancel(false);
    dispatch(resetEditedRows());
    dispatch(setDisabled(true));
    dispatch(setSelectedClaim(JSON.parse(JSON.stringify([...selectedClaim]))));
    getPageClaimsData();
    setBeforeSaveModeVal('');
  }

  useEffect(() => {
    setOldSelectedClaim([...selectedClaim]);
  }, []);

  const saveUnits = async () => {
    const payloadData = [];
    dispatch(setNumOfUnitRes([]));

    editedData.forEach((el) => {
      payloadData.push({
        drugSeqNum: el.drugSeqNum,
        qtr: el.paidQtr,
        claimId: el.claimIdVO.claimId,
        claimLineNum: el.claimIdVO.claimLineNum,
        rebateProgramCd: el.rebateProgramCd,
        labelerCode: el.labelerCode,
        date: formatDateUnix(el.paidDt),
        numOfUnits: el.numOfUnits,
        billedUnits: parseFloat(el.billedUnits),
        contractSeqNum: '',
        isibwdndc: searchScreenReduxObj?.isibwdndc || false,
        isibwdclaim: searchScreenReduxObj?.isibwdclaim || false,
        wdstatuscd: el.wdStatusCd,
        paidQtr: el.paidQtr,
        dramsQtr: null,
        ildisputeresolution: isChecked ? 1 : 0,
        unitsModFromArInd: el.unitsModFromArInd,
        planTypeCd: rebateType === 'Supplemental' ? SUPPLEMENTAL : '',
        userInput: 'yes',
        claimLoadDt: formatDateUnix(el.claimLoadDt),
        corrLinkId: el.corrLinkId,
        userId: userId,
      });
    });

    if (payloadData.length > 0) {
      await dispatch(PostNumOfUnits(payloadData));
    }

    dispatch(setEditedRows([])); // Dispatch to clear editedData in the Redux store

    await dispatch(setDisabled(true));
    dispatch(setSinglePageClaimData(tableData));
    setStateChange('edit', false);
    setOpen(false);
    // dispatch(resetEditedRows());
      // if (selectBy === 'ndc') {
      //   dispatch(searchClaimByNDC(false));
      // }
      // if (selectBy === 'claimId') {
      //   dispatch(GetAndDispatchClaimByID(objClaimId, null, false));
      // }
    dispatch(setCellFocused(-1));
  };

  useEffect(() => {
    if (unitResponse?.status === '200') {
      if (willCloseTab) {
        closeTab('/selected-claim', history, dispatch);
      }
      if (beforeSaveModeVal) {
        dispatch(setSelectedClaimMode(beforeSaveModeVal));
      }
      setSuccessMessages([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      getPageClaimsData();
      // setTimeout(() => setSuccessMessages([]), 5000);
      handleScrollToEvent();
    } else if (unitResponse?.status === '003') {
      dispatch(setErrorMessage([unitResponse?.message]));
    } else if (unitResponse?.status === '002' && !unitResponse?.message) {
      dispatch(setErrorMessage([FAIL_PROCESSING_REQUEST]));
      handleScrollToEvent();
    }
    // dispatch(setClaimLoading(true));
    // getPageClaimsData();
    return () => {
      dispatch(setNumOfUnitRes({}));
    };
  }, [unitResponse?.status]);

  return (
    <div className="tabs-container tBillPanel custom-check">
      <Spinner load={spinnerLoader} />
      <SaveCancelPopup
        open={open}
        title="Save"
        onConfim={() => {
          saveUnits();
          setOpen(false);
        }}
        onCancel={() => {
          setOpen(false);
        }}
      />
      <SaveCancelPopup
        open={openCancel}
        title="Cancel"
        onConfim={() => {
          resetForm();
        }}
        onCancel={() => {
          setOpenCancel(false);
        }}
      />
      <CustomSeparator
        parent1="Display"
        parent2="Claim"
        parent3="Select Claim for Display"
        parent4="Selected Claim"
      />
      {successMessages && (
        <DisplaySuccessMessages
          successMessages={
            typeof successMessages === 'string'
              ? [successMessages]
              : successMessages
          }
        />
      )}
      {errorMessage && (
        <DisplayErrorMessages
          errorMessages={
            typeof errorMessage === 'string'
              ? [...new Set(errorMessage)]
              : errorMessage
          }
        />
      )}
      <div className="row">
        {!fullScreen && !tableFullScreen && (
          <SelectedClaimHeader
            data={selectedClaim}
            pageClaimData={pageClaimData}
            currentIndex={selectedClaimIndex - 1}
            setErrorMessage={setErrorMessage}
            claimSelectByFilter={claimSelectByFilter}
            successMessages={successMessages}
            setSuccessMessages={setSuccessMessages}
          />
        )}
        <SelectedClaimTabContainer
          successMessages={successMessages}
          setSuccessMessages={setSuccessMessages}
          fullScreen={fullScreen}
          setFullScreen={setFullScreen}
          data={pageClaimData}
          currentIndex={0}
          claimReferenceData={claimReferenceData}
          tableFullScreen={tableFullScreen}
          setTableFullScreen={setTableFullScreen}
          systemParameter={systemParameter}
          claimSelectByFilter={claimSelectByFilter}
          setStateChange={setStateChange}
          setErrorMessage={setErrorMessage}
          disableBtn={disableBtn}
          setBeforeSaveModeVal={setBeforeSaveModeVal}
          handleOpenSave={() => {
            openSave();
          }}
        />
      </div>
      {selectedClaimMode != 'display' && (
        <div className="row">
          <div className="col-sm-12">
            <div className="float-right mb-3">
              <div className="btn-wrapper mt-3">
                <Button
                  className="btn btn-success btn-search"
                  onClick={openSave}
                  data-testid="openSave"
                  disabled={disableBtn}
                >
                  <SVGComponent iconName="Icon-awesome-save" /> Save
                </Button>
                <Button
                  className="btn btn-cancel"
                  onClick={() => {
                    setSuccessMessages([]);
                    setOpenCancel(true);
                  }}
                  disabled={disableBtn}
                >
                  <SVGComponent iconName="Icon-cancel" /> Cancel
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectedClaim;
